export default class ArchiveRecruit {
  init() {
    const pageId = 'js-archive-recruit';
    if (!document.getElementById(pageId)) {
      return;
    }

    /**
     * フィルター送信処理
     * HTMLの onchange="submitFilter(this)" から呼び出すために window に追加
     */
    window.submitFilter = (select) => {
      const form = select.closest('form');
      const baseUrl = new URL(
        form.dataset.recruitArchiveUrl || form.action,
        window.location.origin,
      );
      const url = new URL(baseUrl.toString());
      const currentParams = new URLSearchParams(window.location.search);

      currentParams.forEach((value, key) => {
        url.searchParams.set(key, value);
      });

      if (select.value) {
        url.searchParams.set('work_location', select.value);
      } else {
        url.searchParams.delete('work_location');
      }

      url.hash = 'anchor-job-list';

      window.location.href = url.toString();
    };
  }
}